import Compressor from "compressorjs";

const maxAllowedImageUploadSize = 1000000

export const compressImage = function (file, quality, compressedFile, handleSuccess, handleError) {
    if(file.size === 0) {
        handleError("File size is 0");
        return;
    }

    let currentFileSize = compressedFile ? compressedFile.size : file.size;
    if (currentFileSize > maxAllowedImageUploadSize) {
        let newQuality = quality - 0.25;
        if (newQuality < 0) {
            handleError("File size is too big. Max allowed is 1 MB. Sorry the compression did not work - try a better cropped or compressed image.");
            return;
        }
        console.log("Compression try with quality " + newQuality + " and size ", file.size);
        new Compressor(file, {
            quality: newQuality,
            mimeType: 'image/jpeg',
            success: (compressedResult) => {
                console.log("Compression success with new file size ", compressedResult.size);
                compressImage(file, newQuality, compressedResult, handleSuccess, handleError);
            },
            error(err) {
                handleError("File size is too big. Max allowed is 1 MB. Compression failed: " + err.message);
            },
        });
    } else {
        if (compressedFile) {
            handleSuccess(compressedFile);
        } else {
            handleSuccess(file);
        }
    }
}